import React from 'react'
import { UserOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import { format } from 'date-fns'
import SoapInput from 'components/SoapInput/SoapInput'
import {
  Column,
  Avatar,
  Card,
  Info,
  Title,
  Subtitle,
  NavWrapper,
  NavButton,
  Wrapper,
  DoctorProfile,
  LoadingContainer,
} from './index.styled'
import useNotes from './useNotes'
import { convertUtcToEst } from '../../../../../utils/DateAndTimeFormat'

export default function Notes() {
  const { notes, displayedNote, handlePrevious, handleNext, canGoPrevious, canGoNext, isLoading } = useNotes()

  return (
    <Column>
      {isLoading ? (
        <LoadingContainer>
          <Spin />
        </LoadingContainer>
      ) : (
        <>
          <SoapInput height={135} label="S" value={notes.s} readOnly={true} />
          <SoapInput height={135} label="O" value={notes.o} readOnly={true} />
          <SoapInput height={135} label="A" value={notes.a} readOnly={true} />
          <SoapInput height={135} label="P" value={notes.p} readOnly={true} />
        </>
      )}
      <Wrapper style={{ marginTop: 6 }}>
        <Card>
          <DoctorProfile
            size={48}
            shape="circle"
            icon={
              displayedNote?.chiropractor?.user?.profilePic ? (
                <img src={displayedNote?.chiropractor?.user?.profilePic} alt="avatar" />
              ) : (
                <UserOutlined />
              )
            }
          />
          <Info>
            <Title>
              {(displayedNote?.visit?.appointmentTime &&
                format(convertUtcToEst(new Date(displayedNote.visit.appointmentTime)), 'MMMM d')) ??
                '-'}
            </Title>
            <Subtitle>{displayedNote?.visit?.clinic?.name ?? '-'}</Subtitle>
          </Info>
        </Card>

        <NavWrapper>
          <NavButton onClick={handlePrevious} disabled={!canGoPrevious}>
            Previous
          </NavButton>
          <NavButton onClick={handleNext} disabled={!canGoNext}>
            Next
          </NavButton>
        </NavWrapper>
      </Wrapper>
    </Column>
  )
}
